module.exports = __webpack_public_path__ + "static/hero2-c883fcf1955482799a59f8d4a1a1e0dc.jpg";